<!-- PhotoInput.vue -->
<template lang="pug">
div
  v-text-field.photo-input(
    :label="label"
    :value="display"
    prepend-icon="mdi-paperclip"
    readonly
    @click="sheet = true"
    @click:prepend="sheet = true"
  )

  v-bottom-sheet(v-model="sheet")
    v-sheet.pa-4
      .text-subtitle-1.mb-3 {{ label }}

      v-row(dense)
        v-col(cols="6")
          v-btn(block large outlined color="primary" @click="$refs.camera.click()")
            v-icon(left) mdi-camera
            | {{ shots.length ? 'Снять ещё' : 'Камера' }}
        v-col(cols="6")
          v-btn(block large outlined color="primary" @click="$refs.gallery.click()")
            v-icon(left) mdi-image-multiple
            | Галерея

      .d-flex.flex-wrap.mt-3(v-if="shots.length")
        .shot(v-for="(s, i) in shots" :key="s.url")
          img(:src="s.url")
          v-btn.shot__del(x-small icon @click="remove(i)")
            v-icon(small) mdi-close

      v-row.mt-2(dense v-if="shots.length")
        v-col(cols="6")
          v-btn(block text @click="sheet = false") Отмена
        v-col(cols="6")
          v-btn(block color="success" @click="finish(shots.map(s => s.file))") Готово ({{ shots.length }})

  input(ref="camera" type="file" capture="environment" hidden @change="onCamera")
  input(ref="gallery" type="file" accept="image/*" :multiple="multiple" hidden @change="onGallery")
</template>

<script>
export default {
  props: {
    value: { default: () => [] },
    label: String,
    multiple: { type: Boolean, default: false }
  },

  data: () => ({ sheet: false, shots: [] }),

  computed: {
    display() {
      const v = this.value
      if (!v || (Array.isArray(v) && !v.length)) return ''
      return Array.isArray(v) ? `Выбрано: ${v.length}` : v.name
    }
  },

  watch: {
    sheet(open) { if (!open) this.clear() }
  },

  methods: {
    onCamera(e) {
      const file = e.target.files[0]
      e.target.value = ''
      if (!file) return
      if (!this.multiple) return this.finish([file])
      this.shots.push({ file, url: URL.createObjectURL(file) })
    },
    
    onGallery(e) {
      const files = Array.from(e.target.files)
      e.target.value = ''
      if (!files.length) return
      this.finish(this.shots.map(s => s.file).concat(files))
    },
    
    remove(i) {
      URL.revokeObjectURL(this.shots[i].url)
      this.shots.splice(i, 1)
    },

    finish(files) {
      // как v-file-input: массив при multiple, один File без него
      this.$emit('input', this.multiple ? files : files[0])
      this.sheet = false
    },

    clear() {
      this.shots.forEach(s => URL.revokeObjectURL(s.url))
      this.shots = []
    }
  },
  beforeDestroy() { this.clear() }
}
</script>

<style scoped>
.photo-input >>> input { cursor: pointer; }
.shot { position: relative; width: 72px; height: 72px; margin: 4px; }
.shot img { width: 100%; height: 100%; object-fit: cover; border-radius: 4px; }
.shot__del { position: absolute; top: 0; right: 0; background: rgba(255,255,255,.85); }
</style>